import { render } from "./TableQuestion.vue?vue&type=template&id=f3e7d34e&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"

import "./TableQuestion.vue?vue&type=style&index=0&id=f3e7d34e&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e7d34e"]])

export default __exports__